import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux";
import './TVChartContainer.scss'
import { makeid } from "Helpers/helpFunction";
import datafeed from "./help/datafeed";
import { changeInputSearchStock } from "store/actionReducers/StocksAnalysisStore";

export default function TVChartContainerHook({ height = 500 }) {
  const dispatch = useDispatch();
  const [widgetData, setWidgetData] = useState(null)
  const StocksAnalysisStore = useSelector((state) => state?.StocksAnalysisStore);
  const [params, setParams] = useState({
    symbol: StocksAnalysisStore?.inputSearch,
  })

  useEffect(() => {
    if (params?.symbol !== StocksAnalysisStore?.inputSearch) {
      setParams({ ...params, symbol: StocksAnalysisStore?.inputSearch })
    }
  }, [StocksAnalysisStore?.inputSearch])

  useEffect(() => {
    if (params?.symbol) {
      // window.addEventListener('DOMContentLoaded', fetchChart, false);
      fetchChart();
    }
  }, [])

  function getParameterByName(name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
      results = regex.exec(location.search);
    return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
  }

  const fetchChart = () => {
    let getSession = localStorage.getItem('user_id_tradingview')
    if (!getSession) {
      getSession = makeid(7)
      localStorage.setItem('user_id_tradingview', getSession)
    }

    var widget = window.tvWidget = new TradingView.widget({
      // debug: true, // uncomment this line to see Library errors and warnings in the console
      fullscreen: true,
      symbol: params.symbol,
      interval: '1D',
      timezone: "America/New_York",
      container: "tv_chart_container",
      //	BEWARE: no trailing slash is expected in feed URL
      datafeed: datafeed,
      // datafeed: new Datafeeds.UDFCompatibleDatafeed(datafeedUrl),
      library_path: "/charting_library_v2/",
      locale: getParameterByName('lang') || "vi",
      symbol_search_request_delay: 1000,
      disabled_features: ["use_localstorage_for_settings"],
      enabled_features: ["study_templates", 'header_saveload'],
      charts_storage_url: `${process?.env?.REACT_APP_LINK_API_CHART_STORAGE}`,
      charts_storage_api_version: "1.1",
      client_id: `wetrade.dsc.com.vn-${getSession}`,
      user_id: 1,
      theme: 'dark',
      studies_overrides: {
      },
      studies: [
      ],
    });


    setWidgetData(widget)
  }

  const eventTradingview = () => {
    if (widgetData) {
      widgetData.onChartReady(function () {
        widgetData.headerReady().then(function () {
          widgetData.setSymbol(params?.symbol, "5", () => null)
          // widget.setSymbol(params?.symbol, null, null)
          widgetData
            .chart()
            .onSymbolChanged()
            .subscribe(null, function (symbolData) {
              dispatch(changeInputSearchStock({ value: symbolData?.ticker, loading: true }))
              console.log('Symbol change ', symbolData);
              // thisComponent.getPattern();
            });
        });
      });
    }
  }

  useEffect(() => {
    eventTradingview()
  }, [params?.symbol, widgetData])
  return (
    <>
      <div
        id={'tv_chart_container'}
        style={{ height: height }}
        className={'TVChartContainer'}
      />
    </>
  )
}